define(function (require) {
	// general
	const general_utils = require('civicsUtils/general_utilities');
	const radio = require('backbone.radio');
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');
	// templates
	const tpl = require('./templates/t_lov_paging_view.hbs');
	// views
	const PagingCollectionView = require('./v_cpv_paging_view');
	const NavigationView = require('civicsViews/page_view/v_itv_page');
	const FilterView = require('civicsViews/filter_view/v_itv_filter');
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
	const date_utilities = require('civicsUtils/date_utilities');


	const AvailableFeatures = require('civicsUtils/available_features');
	const IpsCollection = require('civicsBase/ipsModelCollection');
	const confirmationModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
	const ModalRegion = require('civicsUtils/modal_region');
	const LiveRegion = require('civicsUtils/live_region_utility');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			pagingViewCont: '.paging-items-container',
			navRegionAbove: '.navigation-region-above',
			navRegionBelow: '.navigation-region-below',
			filterRegion: '.filter-list-sidebar',
			agencyMapRegion: '@ui.agencyMapDiv',
			modalRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			}
		},
		ui: {
			sortByDropdown: '.sortby-dropdown',
			sortingCriteria: '.sortby-option .droppy-input',
			contentToggle: '.content-toggle',
			filterMap: '.filter-list-map',
			sortByContainer: '.sort-by-container',
			navContainer: '.navigation-region',
			navRegionAboveCont: '.navigation-region-above',
			noResultsTextContainer: '.no-results-text',
			mapToggle: '.toggle-input',
			agencyMapDiv: '.records-map.myProjectMap',
			viewCriteria: '.view-criteria .droppy-input',
			viewCriteriaBox: '.view-criteria',
			initialSearchMessage: '.initial-search-message',
			filterContainer: '.filter-list-sidebar',
			mapSearchHelper: '.map-search-helper',
			pagingViewContainer: '.paging-items-container',
		},
		events: {
			'droppyChange @ui.sortByDropdown': 'sortSelected',
			'click @ui.contentToggle': 'toggleWidth',
			'change @ui.mapToggle': 'toggleMapClicked',
			'droppyChange @ui.viewCriteriaBox': 'viewCriteriaChange',
		},
		childEvents: {
			'map:clicked': 'handleMapClicked',
			'rowClicked': 'childModelClicked',
			'criteria:getValue': 'getCriteriaValue',
			'criteria:setValue': 'setCriteriaValue',
			'page:setPreload': 'pageSetPreload',
			'page:getValue': 'pageGetValue',
			'sort:setValue': 'sortSetValue',
			'sort:getValue': 'sortGetValue',
		},
		views: {
			filterView:{
				triggerMethod:function(){}//empty stub to prevent undefined errors.
			}
		},
		initialize: function (options) {
			if (__DEV__) console.log('lov_paging_view -- initialize');
			this.config = options.config;
			this.config.usingSavedQueryForInitialLoadPromise = $.Deferred();
			//HPS-119614 - payment history is not loading results on page load after recent updates to the paging view to support navigating back and forth/saving queries.
			//to fix this, we're adding this  option that will force a default load on page init. the  option must be set by the portlet using this common view.
			if(options.useDefaultQueryOnPageLoad === true){
				//by resolving this promise and passing in a false, we're telling the view to NOT try to use a saved query when fetching results - it will instead use the defaults.
				this.config.usingSavedQueryForInitialLoadPromise.resolve(false);
			}
			this.config.defaultSearchCheckPromise = $.Deferred();
			if (!this.config.globalConfig) {
				this.config.globalConfig = ViewManager.globalConfig().toJSON();
			}
			this.portletName = options.portletName ? options.portletName : 'Portlet';
			this.collection = options.collection; //actual IpsModelCollection
			this.childView = options.childView; //actual child lov view
			this.sortOptions = options.sortOptions; //array of fields for sorting - [{text: 'displaytext', value:'']}]
			this.pageSize = options.pageSize ? options.pageSize : 10;
			this.collection.manageHasMoreRecords = true;
			this.collection.hasMoreRecordsCheckSize = this.pageSize + 1;
			this.page = 1;
			this.initPage = 0;
			this.sortField = options.sortField ? options.sortField : '';
			this.sortDirection = options.sortDirection ? options.sortDirection : '';
			this.passThrough = options.passThrough ? options.passThrough : {};
			this.urlParameters = {};
			this.filters = {};
			//this.totalCount = 5;
			this.noResultsText = options.noResultsText ? options.noResultsText : i18n.t('CIVICS.INSTRUMENT_LIST.NO_RECORDS');
			this.resultsTextKey = options.resultsTextKey ? options.resultsTextKey: 'CIVICS.INSTRUMENT_LIST.RESULTS_LOADED';
			this.mapStateName = this.options.mapStateName;
			this.mapConfigName = this.options.mapConfigName;
			this.mapRegionId = this.options.mapRegionId;
			this.viewOptions = options.viewOptions;
			this.viewFilter = {};
			this.criteriaValue = null;
			this.initialSearchHtml = options.initialSearchHtml ? options.initialSearchHtml : '';
			this.hideNavigationAbove = options.hideNavigationAbove;
			this.isFirstFilter = true;
			this.withParentProjFilter = false;
			this.doNotUpdatePageCount = options.doNotUpdatePageCount;
			var self = this;

			this.mapEnabled = this.config.globalConfig.gis?.enabled && this.mapConfigName;
			//set it on the config object so it gets passed to the children.
			this.config.mapEnabled = this.mapEnabled;
			if (this.mapEnabled) {
				this.setupMapView();
			}

			this.collection.on('remove', () => {
				if (this.collection.toJSON().length == 0) {
					this.ui.noResultsTextContainer.show();
					this.ui.navContainer.hide();
					this.ui.sortByContainer.hide();
					this.ui.pagingViewContainer.hide();
					if(this.ui.resultsAnnouncementContainer) {
						this.ui.resultsAnnouncementContainer.html('');
					}
				} else {
					this.ui.noResultsTextContainer.hide();
					this.ui.navContainer.show();
					this.ui.sortByContainer.show();
					this.ui.pagingViewContainer.show();
					if(this.ui.resultsAnnouncementContainer) {

						this.ui.resultsAnnouncementContainer.html(i18n.t(this.resultsTextKey,{num: this.collection.toJSON().length}));
					}
				}
			});
		},
		onRender: function () {
			if (__DEV__) console.log('lov_paging_view -- onRender');


			if (this.mapEnabled) {
				if (this.mapState === true) {
					this.ui.mapToggle.prop('checked', true);
					this.toggleMapClicked();
				} else {
					this.ui.mapToggle.prop('checked', false);
					this.toggleMapClicked();
				}
			}
		},
		onShow: function () {
			if (this.mapEnabled) {
				this.agencyMapRegion.show(new MapView({
					config: {
						mapConfig: this.mapConfigName,
						channel: this,
						regionId: this.mapRegionId
					}
				}));
			}
			if (__DEV__) console.log('lov_paging_view -- onShow');
			var self = this;
			if (!_.isEmpty(ViewManager.getLocalStorage('CIVICS', this.portletName + '_SortField'))) {
				this.sortField = ViewManager.getLocalStorage('CIVICS', this.portletName + '_SortField');
			}
			if (!_.isEmpty(this.sortField)) { //set default sort field from dropdown
				var sortFieldSplit = this.sortField.split('|');
				if (sortFieldSplit.length > 1) {
					this.ui.sortByDropdown.find('#selectsort').val(sortFieldSplit[0]);
					this.sortField = sortFieldSplit[1];
				} else {
					this.ui.sortByDropdown.find('#selectsort').val(this.ui.sortByDropdown.find('li[data-val="' + self.sortField + '"]').text());
				}
				this.ui.sortByDropdown.find('li[data-val="' + self.sortField + '"]').addClass('pre-selected');

			}
			if (_.isEmpty(this.sortOptions)) {
				this.ui.sortByContainer.hide();
			}
			if (this.viewOptions) {
				$.each(this.config.selectOptions, function () {
					if (this.selected) {
						self.criteriaValue = this.value;
						self.viewFilterBuilder(self.criteriaValue);
					}
				});
			}

			if (this.config.skipInitialSearch) {
				this.ui.navContainer.hide();
				this.ui.sortByContainer.hide();
				this.ui.initialSearchMessage.html(this.initialSearchHtml);
				this.ui.initialSearchMessage.show();
			} else {
				$.when(this.config.usingSavedQueryForInitialLoadPromise).done((usingSavedQueryForInitialSearch) => {
					if (usingSavedQueryForInitialSearch !== true) {
						this.updateCollection(false);
					}
				});
			}


			this.ui.noResultsTextContainer.find('.no-results-response').text(this.noResultsText);
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInit();
			this.$el.find('.droppy').rhyCivicsDroppy();

		},
		templateHelpers: function () {
			var self = this;
			return {
				portletName: this.portletName.replace(/ /g, '_'),
				showSortOption: (this.sortOptions && this.sortOptions.length > 0),
				sortOptions: this.sortOptions,
				mapEnabled: this.mapEnabled,
				mapConfigName: this.mapConfigName,
				showViewOption: (this.viewOptions && this.viewOptions.length > 0),
				isSelected: function (value) {
					var selectValue = false;
					if (self.viewOptions) {
						$.each(self.viewOptions, function (x) {
							if (this.selected == true && this.value == value) {
								selectValue = true;
								return false;
							}
						});
					}
					return selectValue;
				},
				viewByOptions: this.viewOptions,
			};
		},
		//*** END MARIONETTE FUNCTIONS ***///

		// map view is listening to this , to center the map and popup the detail in the map
		childModelClicked: function (childView, model) {
			this.trigger("model:clicked", model);
			// console.log('item clicked - paging view');
		},
		setupMapView: function () {
			this.mapState = ViewManager.getMapState('CIVICS', this.mapStateName);
			//to pass to child views, store on config obj

			this.on("map-trace-extent-handler", info => {
				self.continue(info.options.box);
			});
			this.on("civics:show-details", info => {
				_.forEach(this.pagingView.children._views, view => {
					if (info.selected) {
						_.forEach(info.selected, feature => {
							console.log('feature: ' + feature.attributes.id + '            this.model.id: ' + view.model.id + '  ,  result: ' + feature.attributes.id == view.model.id);
							if (feature.attributes.id === view.model.id) {
								view.triggerMethod("openDetailClicked", info);
							}
						})
					}
				});
			});
			this.mapReadyPromise = $.Deferred();
			this.on("map:ready", function () {
				this.mapReadyPromise.resolve();
			}.bind(this));

			this.on("map:adminfailure", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

		},
		filterUpdated: function (filters, rawData, queryStrings, options) {
			var removeParentProjFilter = false;
			if (rawData) {
				this.rawData = $.extend(true, {}, rawData); // get a truly cloned copy
			} else {
				// if rawData is not passed in, try getting in from the memory
				if (this.rawData) {
					rawData = $.extend(true, {}, this.rawData);
				} else {
					rawData = {};
				}
			}

			// make a copy of the current filters ... ONLY the one from the filter view
			if (filters) {
				this.filters = $.extend(true, {}, filters); // get a truly cloned copy
			} else {
				// if filter is not passed in, try getting in from the memory
				if (!this.filters) {
					this.filters = {};
				}
			}

			if (!this.filters.And) {
				this.filters.And = [];
			}

			//remove IsClosedInstrument filter in this.collections.filter
			if (this.collection.filters && this.collection.filters.And) {
				if(!this.isEmptyLoadFromHash) // since this came from hash fetch, we shouldn't remove this filter
					this.collection.filters.And = this.collection.filters.And.filter((item) => item.property !== 'IsClosedInstrument');
				if (this.isFirstFilter) {
					this.withParentProjFilter = this.collection.filters.And.filter((item) => item.property == 'parentProjectId').length > 0; //set withParentProjFilter only on first filter before removing it
				}else{
					this.collection.filters.And = this.collection.filters.And.filter((item) => item.property !== 'status'); // remove default status filter to handle if the user remove it on search
				}
				this.collection.filters.And = this.collection.filters.And.filter((item) => item.property !== 'parentProjectId'); //remove parentProjectId
			}

			_.each(rawData, function (rawItem) {
				if (_.isArray(rawItem) && rawItem.length > 0) {
					if (_.has(rawItem[0], 'property') && rawItem[0].property != 'status' && rawItem[0].property != 'addedDateTime' && !rawItem[0].property.includes('statusDateCriteria')) {
						removeParentProjFilter = true;
						return false;
					}
				}
			});

			if (!removeParentProjFilter && this.withParentProjFilter) { //push parentProjectId filter
				this.filters.And.push({
					operator: 'LessThanOrEqual',
					property: 'parentProjectId',
					value: 1
				});
			}

			// handle closed / open status check box
			if (rawData.status && rawData.status.length == 1) {
				if (rawData.status[0].value == 'Open') {
					this.filters.And.push({
						operator: 'Equal',
						property: 'IsClosedInstrument',
						value: 'false'
					});
				} else {
					this.filters.And.push({
						operator: 'Equal',
						property: 'IsClosedInstrument',
						value: 'true'
					});
				}
			}

			//add this childEvent on the parent view (onPagingViewFilterUpdated)
			//if you need to add functionality when filter has been updated (before collection fetch)
			this.triggerMethod('pagingViewFilter:updated', rawData);

			this.passThrough = {};


			//if this is the first time through, we might be loading a specific page. otherwise, we're loading the first page.
			this.updateCollection(this.isFirstFilter);


			this.isFirstFilter = false;
			this.isEmptyLoadFromHash = false; // should set to false to prevent duplicate IsClosedInstrument parameter
		},
		sortSelected: function () {
			this.sortField = this.ui.sortByDropdown.find('li[aria-selected="true"]').attr('data-val');
			this.views.filterView.triggerMethod('receive:sort:value', this.ui.sortByDropdown.find('.droppy-input').val());
			ViewManager.setLocalStorage('CIVICS', this.portletName + '_SortField', this.ui.sortByDropdown.find('li[aria-selected="true"] span').text() + '|' + this.sortField);

			this.updateCollection(false);
			this.views.filterView.triggerMethod('update:hash:form', this.criteriaValue);
		},
		//we update the top and bottom views before doing a fetch, so if a user clicks on page 3, page three is highlighted on top and bottom,
		//instead of the previous page they were on being highlighted. When we do this, we need to make sure we don't also update the max, thus adding a "ghost" last page.
		//if skipMax is true, we won't update the max.
		updatePage: function (skipMax) {
			var max = this.page;
			if (this.totalCount) {
				max = Math.ceil(this.totalCount / this.pageSize);
			} else if (skipMax !== true && this.collection.hasMoreRecords) {
				max = this.page + 1;
			}
			if (this.navigationViewAbove) {
				this.navigationViewAbove.page = this.page;
				if (this.totalCount) {
					this.navigationViewAbove.lastPage = max;
				}
				this.navigationViewAbove.currentMax = max;
				this.navigationViewAbove.updateDisplay();
			}

			if (this.navigationViewBelow) {
				this.navigationViewBelow.page = this.page;
				if (this.totalCount) {
					this.navigationViewBelow.lastPage = max;
				}
				this.navigationViewBelow.currentMax = max;
				this.navigationViewBelow.updateDisplay();
			}

			// Updates the URL if not on the first page
			if(this.page > 1) {
				this.views.filterView.triggerMethod('receive:page:value', this.page);
				this.initPage = this.page;
			}

			// console.log('page ' + this.page);
		},
		updatePageCount: function () {
			// This code should run after the page has finished loading so the user shouldn't see when the text changes in the results header
			let collectionCount = new IpsCollection();
			collectionCount.urlRoot = this.collection.urlRoot;
			collectionCount.urlParameters = this.collection.urlParameters;
			collectionCount.isInMyProjects = this.collection.isInMyProjects === true ? true : false;
			collectionCount.url = this.collection.url;
			collectionCount.storedProcedureMode = this.collection.storedProcedureMode;

			let totalCount = 0;

			collectionCount.urlParameters.passThroughObject = collectionCount.urlParameters.passThroughObject ? collectionCount.urlParameters.passThroughObject : {};
			collectionCount.urlParameters.passThroughObject.includecount = true;

			collectionCount.urlParameters.page = [
				{
					Start:1,
					Max:1
				}
			];
			collectionCount.fetch({silent: true}).done(function (response, status, xhrResponse) {
				if (response['total'] !== undefined) {
					totalCount = response['total'];
				}

				$("#resultsList-" + this.portletName.replace(/ /g, '_') + " h3").first().text(i18n.t('CIVICS.COMMON.RESULTS_WITH_COUNT', {num: totalCount}));
			}.bind(this));

		},
		updateCollection: function (isNextPage, isParamSet) {
			var that = this;
			if (!isNextPage) {
				//this.updatePage(1);
				this.totalCount = null;
				//if isNextPage is false, we are going to page one.
				this.page = 1;
			} else {
				this.page = this.initPage;
			}
			if(!isParamSet){
				//filter, sort, navigation
				this.buildUrlParams();
			}

			this.mergeAddedDateTimeAndView();


			let checkMinimumFilterPromise = this.checkMinimumFilter();

			$.when(checkMinimumFilterPromise).done(()=>{
				//console.log(self.filter);
				//fetch data based on this.collection
				// do not clear the error message on first load because this will clear the other error message from other portlet
				if(!this.isFirstFilter)
					ViewManager.resetErrorMessages(this);

				ViewManager.loading(true);

				this.ui.noResultsTextContainer.hide();
				this.ui.initialSearchMessage.hide();
				this.collection.fetch({silent: true}).done(function (response, status, xhrResponse) {
					if (response['total'] !== undefined) {
						this.totalCount = response['total'];
					} else {
						this.triggerMethod('totalCount:updated', this.collection);
					}

					if (response.responseStatus.severity.toLowerCase() == 'warning') {
						var hasSpatialError = false;
						_.each(response.responseStatus.errors, function (item) {
							if (item.message && item.message.includes('spatial data')) {
								hasSpatialError = true;
							}
						});

						if (hasSpatialError) {
							ViewManager.errorToWindow({
								validationError: {
									'message': i18n.t('CIVICS.COMMON.SPATIAL_DATA_ERROR')
								}
							}, this);
						}
						this.disableMapClick = hasSpatialError;
					}

					if (this.collection.toJSON().length == 0) {
						this.ui.noResultsTextContainer.show();
						this.ui.navContainer.hide();
						this.ui.sortByContainer.hide();
						this.ui.pagingViewContainer.hide();
						if(this.ui.resultsAnnouncementContainer) {

							this.ui.resultsAnnouncementContainer.html('');
						}

					} else {
						this.ui.noResultsTextContainer.hide();
						this.ui.navContainer.show();
						this.ui.sortByContainer.show();
						this.ui.pagingViewContainer.show();
						if(this.ui.resultsAnnouncementContainer) {

							this.ui.resultsAnnouncementContainer.html(i18n.t(this.resultsTextKey,{num: this.collection.toJSON().length}));
						}
					}

					this.updatePage();

					this.onCollectionFetchDone(isNextPage);
					ViewManager.loading(false);

					// Announce page content update to assistive technology
					var resultCount = this.collection.toJSON().length;
					if (resultCount === 0) {
						LiveRegion.announcePolite('No results found');
					} else {
						LiveRegion.announcePolite('Page ' + this.page + ', ' + resultCount + ' results loaded');
					}
					$.when(this.mapReadyPromise).done(() => {
						if(!this.disableMapClick) {
							this.trigger('collection:updated', {
								collection: this.collection
							});
						}
					});

				//	this.doNotUpdatePageCount = true;
					if(!this.doNotUpdatePageCount) {
						this.updatePageCount();

					}

				}.bind(this))
					.fail((response, status, xhrResponse) => {
						ViewManager.errorToWindow(response);
						ViewManager.loading(false);

						// Hide UI elements when error occurs
						this.ui.noResultsTextContainer.show();
						this.ui.navContainer.hide();
						this.ui.sortByContainer.hide();
						this.ui.pagingViewContainer.hide();
						this.ui.initialSearchMessage.hide();
					});
			}).fail(()=>{
				if(this.previouslySelectedPage){
					this.page = this.previouslySelectedPage;
					this.previouslySelectedPage = null;
					this.updatePage();
				}
			});
			
		},
		checkMinimumFilter: function(){
			let checkMinimumFilterPromise = $.Deferred();
			if((this.config.minFilterCountWhenNoViewByFilter > 0 || this.config.warningMinFilterCountWhenNoViewByFilter) && (!this.collection.urlParameters.types || this.collection.urlParameters.types.length <= 0))
			{
				let minFilterCount = this.config.minFilterCountWhenNoViewByFilter > 0 ? this.config.minFilterCountWhenNoViewByFilter : this.config.warningMinFilterCountWhenNoViewByFilter;
				let isWarningOnly =  this.config.warningMinFilterCountWhenNoViewByFilter > 0;
				
				let parameterTotalCount = this.getParameterTotalCount();
				if(parameterTotalCount < minFilterCount){
					if(!isWarningOnly){
						this.handleShowErrorState();
					}else{
						this.handleShowWarningState(checkMinimumFilterPromise);
					}
				}else{
					checkMinimumFilterPromise.resolve();
				}
			}else{
				checkMinimumFilterPromise.resolve();
			}

			return checkMinimumFilterPromise;
		},
		getParameterTotalCount:function(){
			// exclude the IsClosedInstrument to handle when user remove this filter and add different field filter, also the parentProjectId filter
			let extendedFilterAndCount = this.collection?.urlParameters?.extendedFilter?.And?.filter?.((item)=> {return item.property != 'IsClosedInstrument' && item.property != 'parentProjectId'})?.length;
			let extendedFilterOrCount = this.collection?.urlParameters?.extendedFilter?.Or?.filter?.((item)=> {return item.property != 'IsClosedInstrument' && item.property != 'parentProjectId'})?.length;
			return (extendedFilterAndCount ?? 0) + (extendedFilterOrCount ?? 0);
		},
		handleShowErrorState: function(){
			this.modalRegion.show(new confirmationModal({
				title: i18n.t('CIVICS.COMMON.FILTER_REQUIRE_TITLE'),
				instructions: i18n.t('CIVICS.COMMON.FILTER_REQUIRE_INSTRUCTION'),
				hideSubmitButton: true,
				cancelButtonText:i18n.t('CIVICS.COMMON.OK')
			}));
			this.modalRegion.showModal();
		},
		handleShowWarningState: function(checkMinimumFilterPromise){
			// only show it if not on first load and not from hashChange event
			// hashchange event trigger by applying the default saved filter
			if(!this.rawData?.updateFromHashChange && !this.isFirstFilter){
				this.modalRegion.show(new confirmationModal({
					title: i18n.t('CIVICS.COMMON.FILTER_WARNING_TITLE'),
					instructions: i18n.t('CIVICS.COMMON.FILTER_WARNING_INSTRUCTION'),
					submitButtonText: i18n.t('CIVICS.COMMON.CONTINUE'),
					cancelButtonText: i18n.t('CIVICS.COMMON.UPDATE_FILTERS'),
					closeAfterSubmit:true,
					confirmationCallback: ()=>{ 
						checkMinimumFilterPromise.resolve();
					},
					cancellationCallback:()=>{
						checkMinimumFilterPromise.reject();
					}
				}));
				this.modalRegion.showModal();
				return checkMinimumFilterPromise;
			}else if(this.isFirstFilter){
				// do not load it on the first load if we didn't met the min filter count
				this.ui.navContainer.hide();
				this.ui.sortByContainer.hide();
				this.ui.pagingViewContainer.hide();
				this.ui.initialSearchMessage.html(this.initialSearchHtml);
				this.ui.initialSearchMessage.show();
			}
		},
		buildUrlParams: function () {
			var self = this;
			var filters = $.extend(true, {}, this.filters);
			if (!filters.And) {
				filters.And = [];
			}
			//add additional filters on the collections
			if (this.collection.filters) {
				if (this.collection.filters.And) {
					filters.And = filters.And.concat(this.collection.filters.And);
				}
				if (this.collection.filters.Or) {
					if (!filters.Or) {
						filters.Or = [];
					}
					filters.Or = filters.Or.concat(this.collection.filters.Or);
				}
			}

			if (this.viewOptions) {
				self.viewFilterBuilder(self.criteriaValue);
			}

			if (!_.isEmpty(this.viewFilter)) {
				filters.And = filters.And.concat(this.viewFilter.And);
			}

			if ((filters.And && filters.And.length > 0) || (filters.Or && filters.Or.length > 0)) {
				//this.urlParameters.extendedFilter = filters;
				if(AvailableFeatures.SubtypeFilterParam()){
					var typeFilters = [];

					if(filters.And.length > 0){
						filters.And.forEach(function(filter){
							if(filter.property.toLowerCase() == 'instrumentsubtype'){
								//get index
								var index = filters.And.indexOf(filter);
								//add to subtype filter
								//InstrumentSubType filter shouldn't be added to typeFilters when filter['value'] is undefined
								if(filter['value']) {
									typeFilters.push({Code: filter['value'], ID: filter['instrumentTypeID']});
									//then remove from And
									filters.And.splice(index, 1);
								}
							}
						});
					}

					if(filters.Or && filters.Or.length){
						var counter = 0;
						filters.Or.forEach(function(filter){
							if(typeof filter.Or != 'undefined'){
								var filterArray = filter.Or,
									isDelete = false;

								filterArray.forEach(function(x){
									if(x.property.toLowerCase() == 'instrumentsubtype'){
										if(x['value']) {
											typeFilters.push({Code: x['value'], ID: x['instrumentTypeID']});

											isDelete = true;
										}
									}
								});

								if(isDelete){
									var index = filters.Or.indexOf(filter);
									filters.Or.splice(index, 1);
									if(filters.Or.length == 0){
										delete filters.Or;
									}
								}
							}
							else{
								var isDelete = false;
								if(filter.property.toLowerCase() == 'instrumentsubtype'){
									if(filter['value']) {
										typeFilters.push({Code: filter['value'], ID: filter['instrumentTypeID']});
										isDelete = true;
									}
									counter++;
								}

								if(counter == filters.Or.length){
									delete filters.Or;
								}
							}
						});
					}

					this.urlParameters.extendedFilter = filters;

					if(typeFilters.length > 0){
						this.urlParameters.types = typeFilters;
					}
					else{
						this.urlParameters.types = [];
					}
				}
				else{
					this.urlParameters.extendedFilter = filters;
				}
			} else {
				this.urlParameters.extendedFilter = {};
			}

			if (!_.isEmpty(this.sortField)) {
				this.urlParameters.orderBy = {
					Property: this.sortField
				} //{Property:'AddedDatetime',direction:'desc'};

				if(!_.isEmpty(this.sortDirection)) {
					this.urlParameters.orderBy.direction = this.sortDirection;
				}
				var selectedSortField = this.getSelectedSortField();
				if (selectedSortField) {
					if (selectedSortField['formatType'] && (selectedSortField['formatType'] == 'date' || selectedSortField['formatType'] == 'currency' || selectedSortField['formatType'] == 'bool')) { //not putting a direction will default to asc. bool as desc to make true display first
						this.urlParameters.orderBy.direction = 'desc';
					}
					if(selectedSortField['isNullLast'])
						this.urlParameters.orderBy.isNullLast = selectedSortField['isNullLast']; // for Oracle order by
					if((selectedSortField['isString'])) 
						this.urlParameters.orderBy.isString = selectedSortField['isString']; // for Oracle specific case-sensitivity
					if((selectedSortField['isDateTime'])) 
						this.urlParameters.orderBy.isDateTime = selectedSortField['isDateTime']; // for Oracle specific case-sensitivity
					if((selectedSortField['dependentProperty'])) // property that has depended. i.e Schedule time, it is dependent on Schedule date.
						this.urlParameters.orderBy.dependentProperty = selectedSortField['dependentProperty']; 
				}
				//add this childEvent on the parent view (onOrderByUpdated) if you need changes to the default order by functionality
				this.triggerMethod('orderBy:updated');
			} else {
				this.urlParameters.orderBy = {
					Property: 'AddedDatetime',
					direction: 'desc'
				};
			}

			var start = ((this.page - 1) * this.pageSize) + 1;
			//add one to the set size. We wil remove this extra record once it's fetched, but if we receive it, then we will know we have more records to fetch.
			this.urlParameters.page = [{
				Start: start,
				Max: this.pageSize + 1
			}];

			if (!_.isEmpty(this.passThrough)) {
				this.urlParameters.passThroughObject = this.passThrough;
			}

			this.collection.urlParameters = this.urlParameters;
			// add builder.buildUrlParameters(this.urlParameters) to the url of the collection
			//console.log(builder.buildUrlParameters(this.urlParameters));
		},
		mergeAddedDateTimeAndView : function() {
			// in some views (such as the public instrument card view), we can't have more than one greater than Added Date Time parameter. 
			// since setting the view adds a second parameter, we choose the one that is later
			if(this.collection.urlParameters !=null && this.collection.urlParameters.extendedFilter !=null  && this.collection.urlParameters.extendedFilter.And != null) {
				var addedDateTimeViews = this.collection.urlParameters.extendedFilter.And.filter(filter =>
					filter.property.toLowerCase() == 'addeddatetime' && filter.operator == 'GreaterThanOrEqual'
				);

				if(addedDateTimeViews.length > 1) {
					var dates = addedDateTimeViews.map(filter => date_utilities.parseDateString(filter.value));
					var highestDate = Math.max.apply(null,dates);
					var dateString = date_utilities.buildISOStringFromDate(new Date(highestDate));

					this.collection.urlParameters.extendedFilter.And = this.collection.urlParameters.extendedFilter.And.filter(filter => 
						!(filter.property.toLowerCase() == 'addeddatetime' && filter.operator == 'GreaterThanOrEqual')
					);

					this.collection.urlParameters.extendedFilter.And.push({
						property: 'addedDateTime',
						operator: 'GreaterThanOrEqual',
						value: dateString
					});
				}
			}
		},
		paginationGoToPageCallback: function (page) {
			this.previouslySelectedPage = this.page;
			this.page = page;
			this.initPage = page;
			this.updatePage(true);
			this.updateCollection(true);

			this.views.filterView.triggerMethod('update:hash:form');
		},
		goToLastPageCallback: function () {
			ViewManager.loading(true);
			//Use the same URL Parameters as the last fetch, but update to only ask for one record to speed thigns up, and enable the includecount attribute
			if (this.collection.urlParameters.passThroughObject) {
				this.collection.urlParameters.passThroughObject.includecount = true;
			} else {
				this.collection.urlParameters.passThroughObject = {
					includecount: true
				};
			}
			this.collection.urlParameters.page = [{
				Start: 1,
				Max: 1
			}];
			this.collection.fetch().done((response, status, xhrResponse) => {
				//remove the include count url parameter. the page start/max will be recalculated by the updateCollection call.
				delete this.collection.urlParameters.passThroughObject.includecount;
				if (response['total'] !== undefined) {
					this.totalCount = response['total'];
				} else {
					this.triggerMethod('totalCount:updated', this.collection);
				}

				if (this.totalCount != undefined) {
					var lastPage = Math.ceil(this.totalCount / this.pageSize);
					this.paginationGoToPageCallback(lastPage);
				}
				ViewManager.loading(false);
			});

		},
		onCollectionFetchDone: function (isNextPage) {
			//on success:
			if (!this.pagingView) {
				if (this.options.collectionView) {
					this.pagingView = new this.options.collectionView({
						collection: this.collection, //this.collection
						childView: this.childView,
						config: this.config,
						disableMapClick: this.disableMapClick
					});
				} else {
					this.pagingView = new PagingCollectionView({
						collection: this.collection, //this.collection
						childView: this.childView,
						config: this.config,
						disableMapClick: this.disableMapClick
					});
				}

				this.pagingViewCont.show(this.pagingView);
			} else {
				this.pagingView.render();
			}

			//add navigation on fetch of collection. assuming total number of items are returned
			//if (!isNextPage) {
				if (!this.options.hideNavigationAbove) {
					if (this.navigationViewAbove) {
						this.navigationViewAbove.destroy();
					}
					//var totalPages = Math.ceil(this.totalCount / this.pageSize); //total number of items / pagesize (round up)
					this.navigationViewAbove = new NavigationView({
						//total: totalPages,
						pageCallback: this.paginationGoToPageCallback.bind(this),
						goToLastPageCallback: this.goToLastPageCallback.bind(this),
						paginationId: this.portletName + "-pageview-pagination-above",
						initPage: this.page
					});
					if (this.collection.hasMoreRecords) {
						this.navigationViewAbove.updateCurrentMax(this.page + 1);
					}
					this.navRegionAbove.show(this.navigationViewAbove);
				} else {
					this.ui.navRegionAboveCont.hide();
				}

				if (this.navigationViewBelow) {
					this.navigationViewBelow.destroy();
				}
				this.navigationViewBelow = new NavigationView({
					//total: totalPages,
					pageCallback: this.paginationGoToPageCallback.bind(this),
					goToLastPageCallback: this.goToLastPageCallback.bind(this),
					paginationId: this.portletName + "-pageview-pagination-below",
					initPage: this.page
				});
				if (this.collection.hasMoreRecords) {
					this.navigationViewBelow.updateCurrentMax(this.page + 1);
				}
				this.navRegionBelow.show(this.navigationViewBelow);
			//}

			if (this.collection.length == 0 && this.initPage > 1) {
				this.goToLastPageCallback();
				//(check BACK and Forward on URL update of last page param when pages are too large for collection)
				this.initPage = 0;
			}
		},
		getSelectedSortField: function () {
			var self = this;

			if(self.sortOptions==null) {
				return null;
			}

			return self.sortOptions.find(o => o.value === self.sortField);
		},
		toggleWidth: function () {
			this.ui.filterMap.toggleClass('full-width');
		},
		toggleMapClicked: function () {
			var stateOfMap = this.ui.mapToggle.is(':checked');
			if (stateOfMap === true) {
				this.ui.agencyMapDiv.show();
				this.ui.mapSearchHelper.show();
				this.ui.filterMap.addClass("show-map").removeClass("hide-map");
				ViewManager.setMapState('CIVICS', this.mapStateName, true);
				//currently only the instrument lookup uses teh map search bar.
				if (this.mapStateName == CN.INSTR_LIST_MAP) {
					this.ui.mapSearchHelper.show();
				} else {
					this.ui.mapSearchHelper.hide();
				}
			} else {
				this.ui.agencyMapDiv.hide();
				this.ui.mapSearchHelper.hide();
				this.ui.filterMap.removeClass("show-map").addClass("hide-map");
				ViewManager.setMapState('CIVICS', this.mapStateName, false);
			};
			ViewManager.triggerResize();
		},
		viewFilterBuilder: function (value) {
			// if the drop down value is anything but "all" == 0
			var filters = {};
			this.viewFilter = {};
			if (!isNaN(value) && value > 0) {
				filters.And = [];

				//If this is last 31 days from today (4/15/2019T08:35:44)
				//Then we want (without time):
				//   From: 3/15/2019
				//Do not add the TO date so we see records in the future.  This is important when your record was adsded in AU or NZ.
				var from = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
				from.setDate(from.getDate() - value);
				var fromFilter = {
					operator: 'GreaterThanOrEqual',
					property: 'AddedDateTime',
					Value: general_utils.dateTimeStringFromDate(from)
				}; //isoFixed

				if (_.isEmpty(filters) || !(filters.And)) {
					filters.And = [fromFilter];
				} else {
					filters.And.push(fromFilter);
				}
				this.viewFilter = filters;
			} else if (value != undefined && isNaN(value)) {
				//making this viewFilterBuilder generic for future use of the viewfilter. make the value of the view as JSON.stringify(value)
				filters.And = [];
				var filterView = {};
				if (this.isJson(value)) {
					var valueJson = JSON.parse(value);
					filterView.operator = valueJson.operator;
					filterView.property = valueJson.property;
					if (valueJson.value != undefined) {
						filterView.value = valueJson.value;
					}
					filters.And.push(filterView);
				}
				this.viewFilter = filters;
			}
		},
		getCriteriaValue: function () {
			var value = this.criteriaValue;
			// Pass the value to the filter
			this.views.filterView.triggerMethod('receive:criteria:value', value);
		},
		setCriteriaValue: function (el, value) {
			this.criteriaValue = value;
			this.ui.viewCriteriaBox.off('droppyChange', 'viewCriteriaChange');
			general_utils.civicsSetDropdownValue(this.ui.viewCriteria, value); // set value of dropdown
			this.ui.viewCriteriaBox.on('droppyChange', 'viewCriteriaChange', this);
		},
		sortSetValue: function (el, value) {
			this.ui.sortingCriteria.off('droppyChange', 'sortSelected');
			general_utils.civicsSetDropdownValue(this.ui.sortingCriteria, value); // set value of dropdown
			this.sortField = general_utils.civicsDropdownValue(this.ui.sortingCriteria);
			this.ui.sortingCriteria.on('droppyChange', 'sortSelected', this);
		},
		pageSetPreload: function(el, value) {
			this.initPage = parseInt(value) || 1;

			// trigger refresh of pagination
			if (this.navigationViewAbove) {
				this.navigationViewAbove.page = this.initPage;
				this.navigationViewAbove.updateDisplay();
			}

			if (this.navigationViewBelow) {
				this.navigationViewBelow.page = this.initPage;
				this.navigationViewBelow.updateDisplay();
			}
		},
		sortGetValue: function() {
			var value = this.ui.sortByDropdown.find('.droppy-input').val();
			// Pass the value to the filter
			this.views.filterView.triggerMethod('receive:sort:value', value);
		},
		pageGetValue: function() {
			var value = this.page;
			// Pass the value to the filter
			this.views.filterView.triggerMethod('receive:page:value', value);
		},
		viewCriteriaChange: function (data) {
			this.criteriaValue = data ? data.result.data : this.dataValue;
			if (this.config.isCustomViewBy) {
				this.triggerMethod('viewBy:updated', this.criteriaValue); // add onViewByUpdated function on parent view if needed
			} else {
				this.updateCollection(false);
			}

			// Call the function to update the URL on criteria change
			this.views.filterView.triggerMethod('update:hash:form', this.criteriaValue);
		},
		onFilterConfigDone: function (filterConfig) {
			this.filterConfig = filterConfig;

			this.filterConfig.usingSavedQueryForInitialLoadPromise = this.config.usingSavedQueryForInitialLoadPromise;
			this.filterConfig.defaultSearchCheckPromise = this.config.defaultSearchCheckPromise; // HPS-142176
			if (this.filterConfig.radioChannel) {
				this.radioChannel = radio.channel(this.filterConfig.radioChannel);
				this.radioChannel.off('filter:updated').on('filter:updated', this.filterUpdated.bind(this));
				this.radioChannel.reply('filter:getUrlParameters', ()=> {
					let cloneURLParameters = $.extend(true, {}, this.urlParameters);
					if(this.viewFilter && cloneURLParameters && cloneURLParameters.extendedFilter && cloneURLParameters.extendedFilter.And){
						let foundViewCriteria = false;
						_.each(cloneURLParameters.extendedFilter.And, (andFilter)=>{
							if(this.viewFilter.And){
								_.each(this.viewFilter.And, (andView)=>{
									if(_.isEqual(andFilter, andView)){
										andFilter.isViewCriteria = true; // flag for view criteria
										andFilter.criteriaValue = this.criteriaValue;
										foundViewCriteria = true;
									}
								});
							}
						});
						if(!foundViewCriteria)
							cloneURLParameters.extendedFilter.And.push({isViewCriteria: true, criteriaValue:0, property:'viewCriteria'});

						cloneURLParameters.dateCriteriaPicker = this.rawData?.dateCriteriaPicker;
						cloneURLParameters.taskOpenClosed = this.rawData?.taskOpenClosed?.length == 2; // task Open and Closed is checked
						cloneURLParameters.taskStatus = this.rawData?.taskStatus?.length == 2;  // task Schedule and unschedule is checked
						cloneURLParameters.assignmentOpenClosed = this.rawData?.assignmentOpenClosed?.length == 2; // assignment Open and Closed is checked
						cloneURLParameters.assignmentStatus = this.rawData?.assignmentStatus?.length == 2; // assignment Schedule and unschedule is checked
						cloneURLParameters.status = this.rawData?.status?.length == 2; // project or lookup Open and Closed is checked
					}

					return cloneURLParameters;
				});
				this.radioChannel.reply('filter:isFirstFilter', () => {
					return this.isFirstFilter;
				});
			}

			this.views.filterView = new FilterView(this.filterConfig);
			this.filterRegion.show(this.views.filterView);
			this.$el.find('.filter-list-controls').addClass('filters-enabled');
			if (this.filterConfig.expanded) {
				this.ui.filterMap.removeClass('full-width');
				setTimeout(function () {
					this.$el.find('.filter-bar').addClass('open');
				}.bind(this), 100) //since it starts with expanded filter. used settimeout because added class is being removed if it is expanded on load

			}
		},
		isJson: function (str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},
		// Reverse function to convert types back to filter structure
		convertTypesToFilters: function (urlParameters) {
			// handle case where urlParameters might be undefined or null
			if (!urlParameters?.types || urlParameters.types.length === 0) {
				return urlParameters?.extendedFilter || {};
			}

			var filters = urlParameters.extendedFilter || {};
			filters.And = filters.And || [];

			var processedTypes = urlParameters.types.map(type => ({
				operator: 'Equal',
				property: 'instrumentSubType',
				value: type.Code,
				instrumentTypeID: type.ID
			}));

			//if there's a single type, we put it in the And. Otherwise, for multiple Types, it goes into the Or
			if(processedTypes.length == 1){
				filters.And.push(processedTypes[0]);
			} else {
				filters.Or = filters.Or || [];
				filters.Or = filters.Or.concat(processedTypes);
			}

			return filters;
		},
		onUpdateCollectionWithHash: function (filters) {
			let preLoadPage = 1;
			if(filters && filters.page){
				// ensure that we always follow the recordsPerPage config even the request came from saved filter
				filters.page[0].Max = (this.config.recordsPerPage ? this.config.recordsPerPage : 10) + 1; 
				preLoadPage = ((filters.page[0].Start - 1) / (filters.page[0].Max - 1)) + 1;
			}
			
			this.pageSetPreload(null, preLoadPage);

			if(filters){
				// Set withParentProjFilter from the collection's initial filters since
				// the hash-load path bypasses filterUpdated where this is normally set (HPS-141299)
				if (this.isFirstFilter && this.collection.filters && this.collection.filters.And) {
					this.withParentProjFilter = this.collection.filters.And.filter((item) => item.property == 'parentProjectId').length > 0;
				}
				this.filters = this.convertTypesToFilters(filters);
				this.collection.urlParameters = filters;
				this.updateCollection(this.isFirstFilter, true);
				this.isFirstFilter = false;

			}else{

				this.collection.urlParameters = {};
				this.isEmptyLoadFromHash = true;
				//the hash is blank - we havent actually made a search yet, so this is still the first filter
				this.isFirstFilter = true;
				this.filterUpdated(); // should execute this so that we can add the default parameter of collection
			}
		}
	});
});
